import { FieldType } from '@ngx-formly/material';
import { subscribe } from 'diagnostics_channel';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { Component, OnDestroy, OnInit } from '@angular/core';

import { ISnFileUploadFormFieldConfigInterface } from '../../interfaces/file-upload-form-field-config.interface';

@Component({
  selector: 'sn-file-upload-form-field',
  templateUrl: './file-upload-form-field.component.html',
  styleUrls: ['./file-upload-form-field.component.scss'],
})
export class FileUploadFormFieldComponent
  extends FieldType<ISnFileUploadFormFieldConfigInterface>
  implements OnInit, OnDestroy
{
  public defaultOptions: ISnFileUploadFormFieldConfigInterface = {
    type: 'file-upload',
  };

  private readonly _destroy$ = new Subject();

  constructor() {
    super();
  }

  public ngOnInit(): void {
    this.formControl.valueChanges.pipe(takeUntil(this._destroy$)).subscribe((files) => {
      if (this.to.change) {
        this.to.change(this.field, files);
      }
      if (this.to.fileUploaded) {
        this.to.fileUploaded(files);
      }
    });
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }
}
